import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES_DROPDOWN } from "./apiRoutes";

interface UseGetCommunitiesDropdownProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunitiesDropdown = async () =>
  await axiosAuth.get(GET_COMMUNITIES_DROPDOWN);

const useGetCommunitiesDropdown = ({
  queryParams,
}: UseGetCommunitiesDropdownProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["communities-dropdown"],
    queryFn: () => getCommunitiesDropdown(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetCommunitiesDropdown;
